import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "@/assets/font/iconfont/iconfont.css"; // 阿里字体图标
import "@/styles/index.scss"; // 全局 css
// 饿了么Loading加载、Notification 通知、Message 消息提示、按钮、导航菜单、滚动、Tooltip 文字提示、Badge 标记、面包屑、头像、下拉菜单,Input,Form,单选框,多选框,选择器,日期选择器、标签、分页、表格、标签页、上传、图片 步骤条，弹窗,Cascader 级联选择器,抽屉
import {
  Loading,
  Notification,
  Message,
  Button,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Scrollbar,
  Tooltip,
  Badge,
  Avatar,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Form,
  FormItem,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Select,
  Option,
  OptionGroup,
  DatePicker,
  Row,
  Col,
  Tag,
  MessageBox,
  Pagination,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Upload,
  Image,
  Steps,
  Step,
  Dialog,
  Popover,
  Cascader,
  Drawer,
  InputNumber,
  Carousel,
  CarouselItem,
  Slider
} from "element-ui";

Vue.prototype.$http = axios;
axios.defaults.baseURL = "/api";
Vue.config.productionTip = false;
Vue.use(Loading);
Vue.prototype.$notification = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Button);
Vue.use(MenuItemGroup);
Vue.use(Scrollbar);
Vue.use(Tooltip);
Vue.use(Badge);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Avatar);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(DatePicker);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tag);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Upload);
Vue.use(Image);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Dialog);
Vue.use(Popover);
Vue.use(Cascader);
Vue.use(Drawer);
Vue.use(InputNumber);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Slider);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
